import React, { useRef } from 'react';
import trash from '../../../assets/images/trashMult.png';
import reload from '../../../assets/images/reload_bookmarks.png';
import { getBookmarks, setBkmSortingType } from "../../../store/bookmarks/actions";
import { useDispatch, useSelector } from "react-redux";
import { useClickDown } from "../../../hooks";
import { ApplicationState } from "../../../store";
import { BookmarkState } from "../../../store/bookmarks/types";

interface Props {
  title: string,
  even: number,
  deleteBkm: (ids: Array<number | string>) => void
}

interface ImageProps {
  src: string,
  width: string,
  alt: string,
  visible: boolean
}

const ImageComponent: React.FC<ImageProps> = ({src, width, alt, visible}) => {
  const ref = useRef<HTMLImageElement>(null);
  useClickDown(ref);

  return (
    <>
      {
        visible && <img src={src}
                        width={width}
                        alt={alt}
                        ref={ref}
        />
      }
    </>
  )
};

interface TextProps {
  content: string
}

const TextComponent: React.FC<TextProps> = ({content}) => {
  const {sorting} = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);
  const {type, direction} = sorting;

  const getArrow = (dir: number) => dir === 1 ? <span>&uarr;</span> : <span>&darr;</span>;

  return (
    <div>
      {content === type && getArrow(direction)}
      {'  ' + content}
    </div>
  )
};


const getContentItem = (title: string, selected: Array<number | string>) => {
  switch (title) {
    case('reload'):
      return <ImageComponent src={reload} alt={'reload'} width={'24px'} visible={true}/>;
    case('delete'):
      return <ImageComponent src={trash} alt={'trash'} width={'20px'} visible={selected.length > 1}/>;
    default:
      return <TextComponent content={title}/>
  }
};

const BookmarkTitleItemComponent: React.FC<Props> = ({title, even, deleteBkm}) => {
  const dispatch = useDispatch();
  const {sorting, selected} = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);

  let onClick = () => {
    const {type, direction} = sorting;

    if (title !== 'reload') {
      type === title
        //@ts-ignore
        ? dispatch(setBkmSortingType({type: type, direction: -1 * direction}))
        : dispatch(setBkmSortingType({type: title, direction: 1}));
    }

    if (title === 'reload') dispatch(getBookmarks());
    if (title === 'delete') {
      if (selected.length > 1) {
        deleteBkm(selected);
      }
    }

  };

  return (
    <div onClick={onClick}
         className={even ? 'bookmarks-title__item litehead ' + title : 'bookmarks-title__item darkhead ' + title}>
      {getContentItem(title, selected)}
    </div>
  );
};

export default BookmarkTitleItemComponent;